<template>
  <div>
    <md-card class="side">
      <md-card-header>
        <div class="md-title">{{client.name}}</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field>
              <label>Nombre</label>
              <md-input v-validate="'required'" v-model="client.name" name="name"></md-input>
            </md-field>
            <span class="md-danger">{{ errors.first('name')}}</span>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>Razón social</label>
              <md-input v-model="client.legalName"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field>
              <label>Rút</label>
              <md-input v-model="client.idnumber"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-button @click="deactivate" v-if="client.isActive" class="md-success">Activo</md-button>
            <md-button @click="deactivate" v-else class="md-danger">Inactivo</md-button>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-side-25">
            <md-field>
              <label>Url</label>
              <md-input v-model="client.v3.url" v-validate="'required|url'" name="url"></md-input>

              <md-button
                :data-clipboard-text="client.v3.url"
                class="md-just-icon md-round clipboard"
                title="copiar ip private"
              >
                <md-icon>file_copy</md-icon>
              </md-button>

              <a :href="'http://'+client.v3.url" target="_blank">
                <md-button class="md-just-icon md-round clipboard" title="copiar ip">
                  <md-icon>insert_link</md-icon>
                </md-button>
              </a>
            </md-field>

            <span class="md-danger">{{ errors.first('url')}}</span>
          </div>
          <div class="md-layout-item md-side-25">
            <md-field>
              <label>Ip</label>
              <md-input v-model="client.v3.ip" v-validate="'required'" name="ip"></md-input>
              <md-button
                :data-clipboard-text="client.v3.ip"
                class="md-just-icon md-round clipboard"
                title="copiar ip pública"
              >
                <md-icon>file_copy</md-icon>
              </md-button>
            </md-field>
            <span class="md-danger">{{ errors.first('ip')}}</span>
          </div>
          <div class="md-layout-item md-side-25">
            <md-field>
              <label>Puerto Node</label>
              <md-input
                v-model="client.v3.nodePort"
                v-validate="'required|integer'"
                name="nodePort"
              ></md-input>
              <md-button
                :data-clipboard-text="client.v3.nodePort"
                class="md-just-icon md-round clipboard"
                title="copiar ip private"
              >
                <md-icon>file_copy</md-icon>
              </md-button>
            </md-field>
            <span class="md-danger">{{ errors.first('nodePort')}}</span>
          </div>
          <div class="md-layout-item md-side-25">
            <md-field>
              <label>Puerto Web</label>
              <md-input v-model="client.v3.webPort" v-validate="'required|integer'" name="webPort"></md-input>
              <md-button
                :data-clipboard-text="client.v3.webPort"
                class="md-just-icon md-round clipboard"
                title="copiar ip pública"
              >
                <md-icon>file_copy</md-icon>
              </md-button>
            </md-field>

            <span class="md-danger">{{ errors.first('webPort')}}</span>
            <div class="md-layout md-alignment-center-left">
              <!-- <div class="md-layout-item md-side-25"> -->
              <!-- <md-autocomplete v-model="client.server.name" :md-options="serversNames">
              <label>Servidor</label>
              </md-autocomplete>-->
              <!-- </div> -->
            </div>
            <center>
              <md-button :class="pingState.url.state" class="md-round">Url {{pingState.url.avg}}</md-button>
              <md-button :class="pingState.ip.state" class="md-round">Ip {{pingState.ip.avg}}</md-button>
              <md-button :class="pingState.node.state" class="md-round">Node {{pingState.node.avg}}</md-button>
            </center>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <!-- <md-button @click="duplicate">Duplicar</md-button> -->
        <md-button class="md-danger md-raised" @click="showDialog = true">Eliminar</md-button>
        <md-button @click="ping">Ping</md-button>

        <md-button @click="set">Guardar</md-button>
      </md-card-actions>
    </md-card>

    <md-dialog :md-active.sync="showDialog" :md-fullscreen="false">
      <md-dialog-title>¿ Estas seguro de eliminar este cliente ?</md-dialog-title>

      <md-dialog-actions>
        <md-button class @click="changeDialog(false)">Cerrar</md-button>
        <md-button class="md-danger" @click="changeDialog(false);deleteClient()">Confirmar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import axios from "axios";
import api from "../../../lib/api.js";
import { mapActions, mapMutations, mapGetters } from "vuex";
import autocomplete from "./autocomplete/autocomplete";
export default {
  name: "ClientComponent",
  components: { autocomplete },
  data() {
    return {
      showDialog: false,
      clients: [],
      client: {
        isActive: true,
        v3: {
          url: "",
          ip: "",
          webPort: null,
          nodePort: null,
          appPort: null,
          sqlPort: null
        },
        server: null,
        phones: [],
        emails: []
      },
      selectedServer: null,
      // completeConfig:{
      //   itemType: 'servers',
      //   initialValue: null,
      //   principalAtribute: 'name',
      //   secondaryAtribute: 'instance',
      //   optionalMultipleAtribute: {1:'provider.name', 2:'provider.name'},
      //   secondaryQuery: null,
      //   placeholder_value: 'Servidor',
      //   searchRoute: '',
      //   res_name: 'server'
      // },
      serversNames: [],
      urlState: "",
      ipState: "",
      nodeState: "",
      pingState: {
        url: {
          state: "",
          avg: ""
        },
        ip: {
          state: "",
          avg: ""
        },
        node: {
          state: "",
          avg: ""
        }
      }
    };
  },
  created() {
    // this.acomplete.searchRoute = api_routes.user.find+'/';
    // this.completeConfig.searchRoute = `${api()}/servers/find/`
    let id = this.$route.query.id;
    if (typeof id !== "undefined") {
      this.get(id)
        .then(res => {
          this.client = res;
          this.selectedServer = res.server.name;
        })
        .catch(err => {
          console.warn(err);
        });
    } else {
      this.clear();
    }
    this.allServers();
  },
  mounted() {},
  // watch: {
  //   clientGetter: function(val) {
  //     // debugger
  //     //
  //     this.completeConfig.initialValue = (this.clientGetter.server != null)?this.clientGetter.server.name : null

  //   }
  // },
  computed: {
    ...mapGetters({
      servers: "servers/servers",
      clientGetter: "clients/client"
    }),

    // completeConfig() {
    //   return {
    //     itemType: 'servers',
    //     initialValue: (this.clientGetter.server != null)?this.clientGetter.server.name : null ,

    //     principalAtribute: 'name',
    //     secondaryAtribute: 'instance',
    //     optionalMultipleAtribute: {1:'provider.name', 2:'provider.name'},
    //     secondaryQuery: null,
    //     placeholder_value: 'Servidor',
    //     searchRoute: '',
    //     res_name: 'server'
    //   }

    // },
    urls() {
      return [
        { url: this.client.v3.url, port: "", name: "url" },
        { url: this.client.v3.ip, port: this.client.v3.webPort, name: "ip" },
        { url: this.client.v3.ip, port: this.client.v3.nodePort, name: "node" }
      ];
    }
  },
  methods: {
    editServer() {
      this.editingServer = true;
      document.getElementById("selectServer").click();
    },
    setServer(event) {
      this.client.server = event.value._id;
    },
    onSelect(val) {
      this.value = val;
    },
    deleteClient() {
      this.delete(this.client._id)
        .then(res => {
          this.$router.push("/clients");

          this.$notify({
            message: "Se ha eliminado el cliente",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          this.$notify({
            message: "Ha ocurrido un error",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });
    },
    changeDialog(state) {
      this.showDialog = state;
    },

    ...mapActions({
      get: "clients/getOne",
      save: "clients/save",
      create: "clients/create",
      allServers: "servers/getAll",
      delete: "clients/delete"
    }),
    ...mapMutations({
      clear: "clients/clear"
    }),
    ping() {
      // console.warn(this.urls);
      this.urls.forEach(i => {
        console.warn(i.url);
        console.warn(i.port);
        console.warn(this.pingState[i.name]);

        axios
          .post(`${api()}/ping`, {
            address: i.url,
            port: i.port,
            timeout: 3000
          })
          .then(res => {
            if (res.data.avg) {
              this.pingState[i.name].state = "md-success";
              this.pingState[i.name].avg = Math.round(res.data.avg);
            } else {
              this.pingState[i.name].state = "md-danger";
              this.pingState[i.name].avg = "";
            }
          })
          .catch(err => {
            this.pingState[i.name].state = "md-danger";
          });
      });
    },
    duplicate() {},
    set() {
      this.$validator.validate().then(result => {
        if (result) {
          if (this.client._id) {
            this.save(this.client).then(res => {
              this.$notify({
                message: "Cliente guardado con exito",
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success"
              });
            });
          } else {
            this.create(this.client).then(res => {
              this.$notify({
                message: "Cliente creado con exito",
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success"
              });
              this.client = res;
              this.$router.push(`/client?id=${res._id}`);
            });
          }
        } else {
          this.$notify({
            message: "Completa los campos requeridos",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "info"
          });
        }
      });
    },
    deactivate() {
      this.client.isActive = !this.client.isActive;
    }
  }
};
</script>
<style scoped>
.md-card.side {
  display: inline-block;
}
</style>
